import axios from './axios'

/**
 * 將前端錯誤上報到 C# API，寫入 publish\logs\*error*.log
 * @param {string} message - 錯誤訊息（必填）
 * @param {{ component?: string, url?: string, detail?: object }} options - 選填
 */
export function logFrontendError(message, options = {}) {
  if (!message || typeof message !== 'string') return
  const url = typeof window !== 'undefined' && window.location ? window.location.href : ''
  const d = options.detail
  const detailStr = (d != null && d !== '') ? (typeof d === 'string' ? d : JSON.stringify(d)) : 'unknown'
  const payload = {
    message: String(message).trim(),
    component: options.component || '',
    url: options.url || url,
    detail: detailStr
  }
  axios.post('/frontend-error', payload).catch(() => {})
}

/**
 * 表單驗證失敗時上報到 error log（頁面需自行 ElMessage.error 顯示 toast）
 * @param {string} message - 錯誤訊息
 * @param {{ component?: string, detail?: object }} options - 選填
 */
export function logValidationError(message = '表單驗證失敗：請檢查表單欄位', options = {}) {
  logFrontendError(message, { ...options, detail: { type: 'validation', ...(options.detail || {}) } })
}
